import _cookies from "../../../shared/utils/_cookies";
import { useAddUserToCloseFriends } from "../api/addUserToCloseFriends";

export default function AddUserToCloseFriends({ studentId, added, children }) {
  const { mutate } = useAddUserToCloseFriends();
  const methods = {
    mutate: () => mutate({ studentId, addUser: !added }),
  };

  if (
    studentId > 9000000 ||
    studentId == _cookies.getItem("auth").user.alunoid
  ) {
    return <></>;
  } else {
    return children(methods);
  }
}
